import type { GamificationStats } from '@testflow/shared';
import { useTranslation } from 'react-i18next';

// GAM-2 „Coverage-Meilensteine" + „gefundene Fehler positiv umgedeutet" (Design-Spec §3.3
// Playlist-Footer). `problems_caught` wird bewusst NIE als Fehlerquote/Pass-Rate dargestellt
// (GAM-2-Guardrail) — nur als absolute, positiv gerahmte Zahl „vor Go-Live gefangen".
export function CoverageMilestone({ stats }: { stats: GamificationStats }) {
  const { t } = useTranslation();
  if (!stats.enabled) return null;

  const remainingPct =
    stats.next_coverage_milestone === null
      ? 0
      : Math.max(0, stats.next_coverage_milestone - stats.coverage_pct);

  return (
    <div className="flex flex-col gap-0.5 text-xs">
      <span className="text-text-body">
        {stats.next_coverage_milestone === null
          ? t('gam.coverageComplete')
          : t('gam.milestoneTo', { pct: remainingPct, milestone: stats.next_coverage_milestone })}
      </span>
      <span className="font-medium text-status-pass">
        {t('gam.problemsCaught', { count: stats.problems_caught })}
      </span>
    </div>
  );
}
